import { GeoCountryEntity } from '../entities';
import { authResource } from './Auth';
export const EncryptionsAccessLogCountryResource = authResource({
    path: '/encryptions/:encryptionId/accesslogs/countries/:countryId?',
    schema: GeoCountryEntity
});
